import {i18n} from "../../../Utils/i18n/i18n";
import {get, map} from 'lodash'
import {DataGridWrapper} from "../../../Utils/DataGridWrapper/DataGridWrapper";
import {SA_getAllPartnersPagination} from "../../../Services/SA_api";
import {formatCompletionDate} from "../../../Utils/BusinessLib";
import {SuperAdminGenerateAPIKey} from "./SuperAdminGenerateAPIKey/SuperAdminGenerateAPIKey";
import {SuperAdminPartnerEditCompanies} from "./SuperAdminPartnerEditCompanies/SuperAdminPartnerEditCompanies";
import './SuperAdminPartnersTable.scss'
import {SuperAdminGenerateClientCreds} from "./SuperAdminGenerateClientCreds/SuperAdminGenerateClientCreds";

/**
 * Builds the columns of the partners table
 * @returns {Promise<Array<object>>} The table columns
 */
const getColumns = async () => {
    return [
        {
            field: 'partnerName',
            headerName: i18n.translate("superAdmin.partnersTable.columns.partnerName"),
            minWidth: 300,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}}>{params.value}</div>,
        },
        {
            field: 'clientSecretExpiresAt',
            headerName: i18n.translate("superAdmin.partnersTable.columns.clientSecretExpiresAt"),
            minWidth: 200,
            sortable: false,
            renderCell: (params) => formatCompletionDate({value: params.value}) || '-',
        },
        {
            field: 'id',
            headerName: i18n.translate("superAdmin.partnersTable.columns.edit"),
            minWidth: 500,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div className="editPartnerRow">
                <SuperAdminGenerateAPIKey partnerId={params.value}/>
                <SuperAdminPartnerEditCompanies partnerId={params.value}/>
                <SuperAdminGenerateClientCreds partnerId={params.value}/>
            </div>
        },
    ];
}

const convertData = (companies) => {
    return map(companies, (company) => {
        return company
    })
}

/**
 * Returns the red row class for a partner whose client secret is expiring
 * @param {object} params - The MUI DataGrid row params
 * @param {object} params.row - The partner row
 * @returns {string} The row CSS class
 */
const getRowClassName = ({row}) => {
    return get(row, 'isClientSecretExpiring') ? 'SuperAdminPartnersTable__row--expiring' : ''
}

const paginationModel = {
    page: 0,
    pageSize: 25,
};
const filterModel = {
    filterValues: {},
    filterData: {},
    showFilters: {
        search: true
    }
}

export const SuperAdminPartnersTable = () => {
    const apiToGetData = async({paginationModel, filterModel}) => {
        return SA_getAllPartnersPagination({paginationModel, filterModel})
    }
    return <DataGridWrapper
        filterModel={filterModel}
        disableColumnFilter
        getColumns={getColumns}
        paginationModel={paginationModel}
        apiToGetData={apiToGetData}
        dataConverter={convertData}
        getRowClassName={getRowClassName}
    />
}